import { call, put } from "redux-saga/effects";

import { apiGeneral, notify } from "services";
import { IUpdateRequest } from "interfaces/update-duck";
import { requestErrorHandler } from "utils";
import { DeleteManyCarrierResponsibleEmailActions } from "store/ducks/settings/carrier-responsible-email";

export function* deleteManyCarrierResponsibleEmailRequest(action: any) {
  try {
    const { putData, onSuccess } = action as IUpdateRequest;

    const { data: responseBody } = yield call(
      apiGeneral.put,
      `/carrier-responsible-email/delete`,
      putData
    );

    const { data } = responseBody;
    yield put(DeleteManyCarrierResponsibleEmailActions.success(data));
    notify("success", "E-mails responsáveis deletados com sucesso");
    if (onSuccess) onSuccess();
  } catch (error) {
    const { errorMessage } = requestErrorHandler(error);
    notify("error", errorMessage);
    yield put(DeleteManyCarrierResponsibleEmailActions.failure(errorMessage));
  }
}
